import getImageSource from './getImageSource';

export default async function youtubeThumbnailResolver(selector, videoUrl, retries = 10) {
    const els = document.querySelectorAll(selector);

    if (els.length) {
        return Promise.all(Array.from(els).map((el) => resolveThumbnail(el, videoUrl)));
    }
    if (retries > 0) {
        return new Promise((resolve) =>
            setTimeout(() => resolve(youtubeThumbnailResolver(selector, videoUrl, retries - 1)), 100)
        );
    }
}

async function resolveThumbnail(el, videoUrl) {
    const bgMatch = el.style.backgroundImage.match(/url\(["']?(.+?)["']?\)/);
    let orig = bgMatch?.[1];

    if (!orig && videoUrl) {
        const id = videoUrl.split('/').pop();

        orig = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
    }

    if (!orig) {
        return;
    }

    const tryUrls = [
        orig.replace(/(hq|sd)?default/gi, 'maxresdefault'),
        orig.replace(/(hq|sd)?default/gi, 'hqdefault'),
        orig.replace(/(hq|sd)?default/gi, 'sddefault'),
        orig.replace(/(hq|sd)?default/gi, 'default'),
    ];

    const src = await getImageSource(tryUrls, orig, { minWidth: 480 });

    el.style.backgroundImage = `url("${src}")`;
}
